import {
  IConversation,
  IMember,
  IMessage,
  IContactInfo,
  ConversationTypeEnum,
} from "@auvious/integrations";
import { ConversationStateEnum } from "../../models";

export enum ConversationActions {
  CONVERSATION_DATA_CHANGE = "CONVERSATION_DATA_CHANGE",
  CONVERSATION_STATE_CHANGE = "CONVERSATION_STATE_CHANGE",
  CONVERSATION_TYPE_CHANGE = "CONVERSATION_TYPE_CHANGE",
  CONVERSATION_REQUEST_CHANGE = "CONVERSATION_REQUEST_CHANGE",
  CONVERSATION_ENDED = "CONVERSATION_ENDED",
  AGENT_CHANGE = "AGENT_CHANGE",
  MESSAGE_RECEIVED = "MESSAGE_RECEIVED",
  MESSAGE_SENT = "MESSAGE_SENT",
  MESSAGE_ERROR = "MESSAGE_ERROR",
  MESSAGE_METADATA_CHANGE = "MESSAGE_METADATA_CHANGE",
  MEMBER_SET = "MEMBER_SET",
  MEMBER_REMOVE = "MEMBER_REMOVE",
  AGENT_TYPING_CHANGE = "AGENT_TYPING_CHANGE",
  CUSTOMER_CHANGE = "CUSTOMER_CHANGE",
  CONVERSATION_MINIMIZE_CHANGE = "CONVERSATION_MINIMIZE_CHANGE",
}

export interface ConversationDataChange {
  type: ConversationActions.CONVERSATION_DATA_CHANGE;
  payload: IConversation;
}
export interface ConversationStateChange {
  type: ConversationActions.CONVERSATION_STATE_CHANGE;
  payload: ConversationStateEnum;
}
export interface ConversationTypeChange {
  type: ConversationActions.CONVERSATION_TYPE_CHANGE;
  payload: ConversationTypeEnum;
}
export interface ConversationRequestChange {
  type: ConversationActions.CONVERSATION_REQUEST_CHANGE;
  payload: IContactInfo;
}
export interface ConversationEnded {
  type: ConversationActions.CONVERSATION_ENDED;
}
export interface AgentChange {
  type: ConversationActions.AGENT_CHANGE;
  payload: IMember;
}
export interface CustomerChange {
  type: ConversationActions.CUSTOMER_CHANGE;
  payload: IMember;
}
export interface MessageReceived {
  type: ConversationActions.MESSAGE_RECEIVED;
  payload: IMessage;
}
export interface MessageSent {
  type: ConversationActions.MESSAGE_SENT;
  payload: IMessage;
}
export interface MessageError {
  type: ConversationActions.MESSAGE_ERROR;
  payload: IMessage;
}

export interface MessageMetadataChange {
  type: ConversationActions.MESSAGE_METADATA_CHANGE;
  payload: { id: string; metadata: { [key: string]: any } };
}
export interface MemberSet {
  type: ConversationActions.MEMBER_SET;
  payload: IMember;
}
export interface MemberRemove {
  type: ConversationActions.MEMBER_REMOVE;
  payload: IMember;
}
export interface AgentTypingChange {
  type: ConversationActions.AGENT_TYPING_CHANGE;
  payload: boolean;
}

export interface ConversationMinimizeChange {
  type: ConversationActions.CONVERSATION_MINIMIZE_CHANGE;
  payload: boolean;
}

export const dispatchConversationDataChange =
  (payload: IConversation) => (dispatch, _getState) => {
    return dispatch({
      type: ConversationActions.CONVERSATION_DATA_CHANGE,
      payload,
    } as ConversationDataChange);
  };
export const dispatchConversationStateChange =
  (payload: ConversationStateEnum) => (dispatch, _getState) => {
    return dispatch({
      type: ConversationActions.CONVERSATION_STATE_CHANGE,
      payload,
    } as ConversationStateChange);
  };
export const dispatchConversationTypeChange =
  (payload: ConversationTypeEnum) => (dispatch, _getState) => {
    return dispatch({
      type: ConversationActions.CONVERSATION_TYPE_CHANGE,
      payload,
    } as ConversationTypeChange);
  };
export const dispatchConversationRequestChange =
  (payload: IContactInfo) => (dispatch, _getState) => {
    return dispatch({
      type: ConversationActions.CONVERSATION_REQUEST_CHANGE,
      payload,
    } as ConversationRequestChange);
  };
export const dispatchConversationEnded = () => (dispatch, _getState) => {
  return dispatch({
    type: ConversationActions.CONVERSATION_ENDED,
  } as ConversationEnded);
};
export const dispatchAgentChange =
  (payload: IMember) => (dispatch, _getState) => {
    return dispatch({
      type: ConversationActions.AGENT_CHANGE,
      payload,
    } as AgentChange);
  };
export const dispatchCustomerChange =
  (payload: IMember) => (dispatch, _getState) => {
    return dispatch({
      type: ConversationActions.CUSTOMER_CHANGE,
      payload,
    } as CustomerChange);
  };
export const dispatchMessageReceived =
  (payload: IMessage) => (dispatch, _getState) => {
    return dispatch({
      type: ConversationActions.MESSAGE_RECEIVED,
      payload,
    } as MessageReceived);
  };
export const dispatchMessageError =
  (payload: IMessage) => (dispatch, _getState) => {
    return dispatch({
      type: ConversationActions.MESSAGE_ERROR,
      payload,
    } as MessageError);
  };
export const dispatchMessageMetadataChange =
  (payload: { id: string; metadata: { [key: string]: any } }) =>
  (dispatch, _getState) => {
    return dispatch({
      type: ConversationActions.MESSAGE_METADATA_CHANGE,
      payload,
    } as MessageMetadataChange);
  };
export const dispatchMessageSent =
  (payload: IMessage) => (dispatch, _getState) => {
    return dispatch({
      type: ConversationActions.MESSAGE_SENT,
      payload,
    } as MessageSent);
  };
export const dispatchMemberSet =
  (payload: IMember) => (dispatch, _getState) => {
    return dispatch({
      type: ConversationActions.MEMBER_SET,
      payload,
    } as MemberSet);
  };
export const dispatchMemberRemove =
  (payload: IMember) => (dispatch, _getState) => {
    return dispatch({
      type: ConversationActions.MEMBER_REMOVE,
      payload,
    } as MemberRemove);
  };
export const dispatchAgentTypingChange =
  (payload: boolean) => (dispatch, _getState) => {
    return dispatch({
      type: ConversationActions.AGENT_TYPING_CHANGE,
      payload,
    } as AgentTypingChange);
  };
export const dispatchConversationMinimizeChange =
  (payload: boolean) => (dispatch, _getState) => {
    return dispatch({
      type: ConversationActions.CONVERSATION_MINIMIZE_CHANGE,
      payload,
    } as ConversationMinimizeChange);
  };

// export const connectingAction = () => async (dispatch, _getState) => {
//     return dispatch({
//         type: Actions.CONNECTING
//     } as Connecting);
// };

// export const changeName = (name: string):
//     ThunkAction<Promise<void>, RootState, void, Action> => async (dispatch, getState) => {
//         // await fetch(...); // some async operation
//     };
